import React, { useEffect } from 'react'
import Button from '@mui/material/IconButton';
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { offerHide, activeCoupon } from '../features/offerSlice';
import api from '../controller/api'
import { couponData } from '../features/offerSlice';

export default function Offer() {
    const dispatch = useDispatch()
    const coupons = useSelector(activeCoupon)

    const getCoupon = async () => {
        try {
            const { data: res } = await api.get("/coupon/list")
            const result = res.data.find((item) => item.couponShow === true)
            dispatch(couponData(result))
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getCoupon()
    }, [])

    return (
        <div className='offer-box'>
            {
                coupons?.couponShow === true
                    ? <h4>Receive {coupons?.discount}% Special Offfer today! 🎁 Just create a Home Salon account and the magic will happen ! Code {coupons?.name}</h4>
                    : <h4>Just create a Home Salon account and the magic will happen</h4>
            }
            <Button variant="contained" color="error" onClick={() => dispatch(offerHide())}>
                <IoClose />
            </Button>
        </div >
    )
}
